<template>
  <el-table ref="tableRef" :height="tableHeight" v-bind="$attrs" v-on="$listeners">
    <template v-for="(slot, key) in $scopedSlots" :slot="key" slot-scope="scope">
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
  </el-table>
</template>

<script>
import { debounce } from "vue2-element-admin-plugin"
export default {
  name: "autoHeightTable",
  unAutoRegister: true, // 不自动注册
  props: {
    instanceHeight: {
      type: [Number, String],
      default: 288
    },
    minHeight: {
      type: [Number, String],
      default: 300
    }
  },
  data() {
    return {
      tableHeight: "auto" // 初始高度为 auto
    }
  },
  mounted() {
    // 为当前组件实例创建独立的防抖函数
    this.handleResize = debounce(this.calculateTableHeight, 10)
    window.addEventListener("resize", this.handleResize)

    this.calculateTableHeight()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    calculateTableHeight() {
      this.$nextTick(() => {
        // 计算表格高度（屏幕高度减去其他元素高度）
        const otherHeight = Number(this.instanceHeight) // 其他元素高度（如顶部导航、搜索栏等）
        const tableHeight = window.innerHeight - otherHeight
        this.tableHeight = tableHeight < this.minHeight ? this.minHeight : tableHeight // 最小高度 默认 300
      })
    },
    toggleRowSelection() {
      this.$refs.tableRef.toggleRowSelection(...arguments)
    },
    clearSelection() {
      this.$refs.tableRef.clearSelection(...arguments)
    },
    toggleAllSelection() {
      this.$refs.tableRef.toggleAllSelection(...arguments)
    },
    setCurrentRow() {
      this.$refs.tableRef.setCurrentRow(...arguments)
    },
    toggleRowExpansion() {
      this.$refs.tableRef.toggleRowExpansion(...arguments)
    },
    clearSort() {
      this.$refs.tableRef.clearSort(...arguments)
    },
    clearFilter() {
      this.$refs.tableRef.clearFilter(...arguments)
    },
    doLayout() {
      this.$refs.tableRef.doLayout(...arguments)
    },
    sort() {
      this.$refs.tableRef.sort(...arguments)
    }
  }
}
</script>